// StatusBar.tsx
import React from 'react';
import IconSwitch from '../../IconSwitch';
import './statusbar.scss';
import { ReactComponent as RedAlertIcon } from '../../../images/red-alert.svg';

interface StatusBarProps {
    statusCounts: {
        [key: string]: { count: number; color: string };
    };
}

const statuses = ['Maintenance', 'Moving', 'Idle', 'Parked', 'Offline','Alerts' ];

const StatusBar: React.FC<StatusBarProps> = ({ statusCounts }) => {
    return (
        <div className="status-bar">
            {statuses.map((status) => {
                const { count, color } = statusCounts[status] || { count: 0, color: '#999' };
                return (
                    <div key={status} className={`status-item ${status.toLowerCase()}_status`}>
                        {status !== 'Alerts' && <IconSwitch name="map-pin" color={color} />}
                        <section className="count-n-state">
                            <div>{count}</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                {status === 'Alerts' && (
                                    <RedAlertIcon style={{ width: 16, height: 16, marginRight: 4 }} />
                                )}
                                {status.toUpperCase()}
                            </div>
                        </section>
                    </div>
                );
            })}
        </div>

    );
};

export default StatusBar;
